import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Form } from "react-bootstrap";
import EditCustomComponent from "../tenants/EditCustomComponent";
import { OrganizationUserRolesEnum, OrganizationUserService } from "@propertelligent/client-api";
import { GetImages } from "../../utils/GetImages";
import apiHelper from "../../utils/apiHelper";
import { useError } from "../../utils/context/ErrorContext";
import { checkEmptyFieldsFunc, validateEmail, validateFirstName, validateLastName, validateNumber } from "../../utils/validateHelper";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import AddTraspButton from "../firstTimeUserExperience/commonCom/AddTraspButton";
import RequestBreadcrumb from "../common/RequestBreadcrumb";
import { URLS } from "../../constants/constants";
import RadioButton from "../common/RadioButton";
import CustomInputs from "../common/Inputs";
import { UserLoginData } from "../common/charts/Enums";

const Adduser = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const orgId = parseInt(sessionStorage.getItem(UserLoginData.organization_id));
  const [userTypeError, setUserTypeError] = useState(false);
  const [organizationUserTypeId, setOrganizationUserTypeId] = useState(OrganizationUserRolesEnum.Admin);
  const { errors, setErrors, setErrorMessages, errorMessages, clearErrors } = useError();
  const [userStatus, setUserStatus] = useState("")
  const [values, setValues] = useState({
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  const [PreviousState, setPreviousState] = useState({
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  const getUserData = () => {
    if (id) {
      apiHelper(
        OrganizationUserService.getApiOrganizationUser,
        { showNotification: false },
        Number(id)
      )
        .then((res) => {
          if (res?.data?.success) {

            setValues({
              title: res?.data?.success?.title,
              firstName: res?.data?.success?.firstName,
              lastName: res?.data?.success?.lastName,
              email: res?.data?.success?.email,
              phoneNumber: res?.data?.success?.phoneNumber,
            });

            setPreviousState({
              title: res?.data?.success?.title,
              firstName: res?.data?.success?.firstName,
              lastName: res?.data?.success?.lastName,
              email: res?.data?.success?.email,
              phoneNumber: res?.data?.success?.phoneNumber,
            });

            setUserStatus(res?.data?.success?.formatted?.UserStatus)
            setOrganizationUserTypeId(res?.data?.success?.organizationUserTypeId);
          }
        })
        .catch((err) => { });
    }
  };

  const handleChange = (value, key) => {
    const errorKey = `${key}`;
    setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
    setErrorMessages((prevMessages) => ({ ...prevMessages, [errorKey]: "" }));
    setValues({ ...values, [key]: value });
  };

  useEffect(() => {
    if (checkEmptyFieldsFunc(values, clearErrors, errors, errorMessages, setErrors, setErrorMessages, undefined)) {
      clearErrors();
    }
    getUserData()
  }, [id]);

  const formDetails = [
    {
      label: "Title",
      placeholder: "Title",
      value: values.title,
      name: "title",
      blurFunction: () => {
        if (values.title.trim() == "") {
          setErrors({ ...errors, title: true })
        } else {
          setErrors({ ...errors, title: false })
        }
      },
      errorMessages: errorMessages.title,
      isError: errors.title,
      type: "text",
      required: true
    },
    {
      label: "First Name",
      placeholder: "Enter First Name",
      value: values.firstName,
      name: "firstName",
      blurFunction: () => validateFirstName(values.firstName, setErrors, setErrorMessages),
      errorMessages: errorMessages.firstName,
      isError: errors.firstName,
      type: "text",
      required: true
    },
    {
      label: "Last Name",
      placeholder: "Enter Last Name",
      value: values.lastName,
      name: "lastName",
      blurFunction: () => validateLastName(values.lastName, setErrors, setErrorMessages),
      errorMessages: errorMessages.lastName,
      isError: errors.lastName,
      type: "text",
      required: true
    },
    {
      label: "Email Address",
      placeholder: "Enter Email Address",
      value: values.email,
      name: "email",
      blurFunction: () => validateEmail(values.email, setErrors, setErrorMessages),
      errorMessages: errorMessages.email,
      isError: errors.email,
      type: "email",
      required: true
    },
    {
      label: "Phone Number",
      placeholder: "Enter Phone No.",
      value: values.phoneNumber,
      name: "phoneNumber",
      blurFunction: () => validateNumber(values.phoneNumber, setErrors, setErrorMessages),
      errorMessages: errorMessages.phoneNumber,
      isError: errors.phoneNumber,
      type: "mobile",
      required: true,
      maxLength: 10
    },
  ];

  const addUserHandler = async (e) => {
    e.preventDefault();
    const payload = {
      ...values,
      organizationUserTypeId: organizationUserTypeId,
      organizationId: orgId
    };
    if (checkEmptyFieldsFunc(payload, clearErrors, errors, errorMessages, setErrors, setErrorMessages, undefined)) {
    }

    else {

      if (!id) {
        apiHelper(OrganizationUserService.postApiOrganizationUser, {
          successMessage: "User Invited Successfully", failureMessage: "Unable to Invite User", showNotification: true,
        }, payload).then((res) => {
          if (res?.data?.success) {
            setValues({
              title: "",
              firstName: "",
              lastName: "",
              email: "",
              phoneNumber: "",
            });
          }
          setOrganizationUserTypeId(1);
        });
      }

      else {

        if (userStatus === "Active") {

          const payload = {
            ...values,
            organizationUserTypeId: organizationUserTypeId,
            organizationUserId: Number(id),
            organizationId: orgId
          };
          apiHelper(OrganizationUserService.putApiOrganizationUser, {
            successMessage: "User edited successfully", failureMessage: "Unable to edit user",
            showNotification: true,
          }, id, payload)
            .then((res) => {
              getUserData();
            })
            .catch((error) => { });
        }
        else {

          const keys = Object.keys(values);

          const isChanged = keys.some(key => PreviousState[key] !== values[key]);

          if (isChanged) {

            try {
              const payload = {
                ...values,
                organizationUserTypeId,
                organizationUserId: Number(id),
                organizationId: orgId,
              };

              await apiHelper(
                OrganizationUserService.putApiOrganizationUser,
                {
                  successMessage: "User edited successfully",
                  failureMessage: "Unable to edit user",
                  showNotification: true,
                },
                id,
                payload
              );

              await apiHelper(
                OrganizationUserService.putApiOrganizationUserResendInvite,
                {
                  successMessage: "User invited successfully",
                  failureMessage: "Unable to invite user",
                  showNotification: true,
                },
                id
              );

              getUserData();
            } catch (error) {
              console.error("Error during user edit or invite:", error);
            }

          }

          else {
            apiHelper(OrganizationUserService.putApiOrganizationUserResendInvite,
              {
                successMessage: "User Invited Successfully",
                failureMessage: "Unable to Invite User",
                showNotification: true,
              }, id)
              .then((res) => {
                getUserData();
              })
              .catch((error) => { });
          }



        }
      }
    }
  };

  return (
    <div className="organizationUserContainer"
    >
      <form onSubmit={addUserHandler}>
        <RequestBreadcrumb
          firstName={"Dashboard"}
          link={URLS.HOME}
          lastName={"My Organization"}
          link1={undefined}
          currentStep="User Detail"
        />
        <div className="addContractorFormContainer mb-3">
          <div className="newTenantFormTopBar d-flex align-items-center">
            <img
              onClick={() => {
                navigate("/organization/manage-users", { state: true });
              }}
              height={28}
              width={28}
              src={GetImages.leftChevronBlack}
              className="clickable"
            />
            <p className="newTenantFormHeading"> Add a user</p>
          </div>
          <div className="newTenantDesciptionContainer mb-3">
            <p className="newTenantDescriptionText sub_text black">Select User Role *</p>
          </div>
          <div>
            <div className="d-flex radioButtonContainer">
              <RadioButton
                label="Organization Admin"
                name="group1"
                id="organizationAdmin"
                value={undefined}
                checked={organizationUserTypeId === 1}
                onChange={() => {
                  setOrganizationUserTypeId(1);
                  setUserTypeError(false);
                }}
              />
              <RadioButton
                label="Property Manager"
                name="group1"
                id="propertyManager"
                value={undefined}
                checked={organizationUserTypeId === 2}
                onChange={() => {
                  setOrganizationUserTypeId(2);
                  setUserTypeError(false);
                }}
              />
            </div>
            <div>
              {userTypeError && (<p className="errorMessage"> Please select user role </p>)}
            </div>
          </div>
          <div className="newTenantDesciptionContainer mb-3">
            <p className="newTenantDescriptionText sub_text black">
              Enter basic details of users{" "}
            </p>
          </div>
          <div className="d-flex addContractorInputContainer">
            {formDetails.map((item) => {
              return (
                <CustomInputs
                  key={item.label}
                  labelText={item.label}
                  placeholder={item.placeholder}
                  value={item.value}
                  name={item.name}
                  onChange={(e) => handleChange(e.target.value, item.name)}
                  onBlur={item.blurFunction}
                  errorMessages={item.errorMessages}
                  isError={item.isError}
                  width="204px"
                  type={item.type}
                  required={item.required}
                  maxLength={item.maxLength}
                />
              );
            })}
          </div>
        </div>
        <div
          style={{ marginTop: "75px", bottom: 0, position: "absolute" }}
          className="newTanentBottomBar">
          <AddTraspButton
            type="button"
            bname="Cancel"
            onClick={() => { navigate("/organization/manage-users") }}
            width="fit-content"
          />
          <AddButtonWithArrow
            type="submit"
            buttonname={userStatus.includes("Invitation Pending") ? "Resend Invite" : id ? "Save" : "Send Invite"}
          />

        </div>
      </form>
    </div>
  );
};

export default Adduser;
